// src/store/authSlice.js
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  user: null, // { id, username, email, role, status }
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    // Accept just the user object (cookie is set by server; no token here)
    loginSuccess(state, action) {
      state.user = action.payload?.user || null;
    },
    setUser(state, action) {
      state.user = action.payload || null;
    },
    logout(state) {
      state.user = null;
    },
  },
});

export const { loginSuccess, setUser, logout } = authSlice.actions;

// Handy selectors
export const selectUser = (state) => state.auth.user;
export const selectIsAuthenticated = (state) => Boolean(state.auth.user);

export default authSlice.reducer;
